// Collections is now a Product Type facet. Keep the legacy quiz markup stable,
// but bind its category choices to metaobject GIDs so label changes and
// translations cannot break matching.
const quizProductTypeValues = {
  Curtains: "gid://shopify/Metaobject/133957648634",
  "Outdoor Curtains": "gid://shopify/Metaobject/133957681402",
  "Sun Shade Sail": "gid://shopify/Metaobject/133957714170",
};

// The old Style step used Collections values as inaccurate style proxies.
// Remove it until a dedicated custom.style field has been audited.
$('.quiz .quizContainer .quizStep[name="Style"]').remove();

$(".quiz .quizContainer .quizStart .quizBox .btn").on(
  "click",
  function () {
    quizStepChange();

    $(".quiz .quizContainer .quizStep").each(function () {
      $(this).find(".quizItem").removeClass("active").removeClass("disabled");
      $(this).find(".quizBoxBottom .btn").text("SKIP").css("display", "none");
      $(this).find(".quizBox > .quizBoxTop .btn").css("display", "none");
      if ($(this).index() > 1) {
        $(this).css("display", "none");
      }
    });

    $(".quiz .quizContainer .quizEnd, #ProductGridContainer").css("display", "none");
    $('facet-filters-form input:checked').next().click();
  }
);

function quizStepChange (type = "Category", index = -1) {
  var ele = "";
  var maxNum = 0;
  index++;

  if (type == "Category" && index == 0) {
    ele = $('.quiz .quizContainer .quizStep[name="Category"]');
  } else {
    // Outdoor and Sun Shade Sail steps in the legacy template use a trailing
    // "1" in their type. Resolve that safely without changing the template.
    if ($(`.quiz .quizContainer .quizStep[type="${type}"]`).length === 0) {
      type = `${type}1`;
    }
    maxNum = $(`.quiz .quizContainer .quizStep[type="${type}"]`).length + 1;
  }

  if (index > 0 && index <= maxNum) {
    ele = $(
      `.quiz .quizContainer .quizStep[type="${type}"][step="${index}"]`
    );
  }

  if (index > maxNum) {
    ele = $(".quiz .quizContainer .quizEnd, #ProductGridContainer");
  }
  
  ele.css('display', 'block');
  windowScrollTop(ele);
}

$(".quiz .quizContainer .quizStep .quizBox .quizBoxBody .quizItem").on(
  "click",
  function () {
    if ($(this).hasClass("disabled")) {
      return;
    }
    var container = $(this).closest(".quizBox");

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      if ($(this).closest(".quizStep").attr("name") == "Category") {
        $(this).parent().find(".quizItem").removeClass("active");
      }
      $(this).addClass("active");
    }

    container
      .find(".quizBoxBottom .btn")
      .css("display", "flex")
      .text(
        container.find(".quizBoxBody .active").length > 0
          ? "NEXT STEP"
          : "SKIP"
      );
    if ($(this).closest(".quizStep").attr("name") == "Category") {
      container.css("display", container.find(".quizBoxBody .active").length > 0 ? "flex" : "none");
    }
    filterChange();
  }
);

function filterChange () {
  $.each($('.quizStep .quizItem'), function (i, item) {
    const itemBox = $(item).find('.itemBox');
    const name = itemBox.attr('name');
    const type = itemBox.attr('type');
    if (!name) return;

    const productTypeValue = name.toLowerCase() === 'custom.collections'
      ? quizProductTypeValues[type]
      : null;
    if (!type && !productTypeValue) return;

    const filterInputs = $(`facet-filters-form input[name*="${name}" i]`);
    const filterEvent = productTypeValue
      ? filterInputs.filter((i, filterItem) => $(filterItem).val() === productTypeValue)
      : filterInputs.filter((i, filterItem) => {
          return $(filterItem).next().find('span').text().trim() == type;
        });

    if (filterEvent.length > 0) {
      filterEvent.prop('checked', !$(item).hasClass('active'));
      filterEvent.next().click();
    }
  })
}

$(".quiz .quizContainer .quizStep .quizBox .quizBoxTop .btn").on(
  "click",
  function () {
    const currentNum = $(this).closest(".quizStep").index();
    $(this).css("display", "none");

    $(".quiz .quizContainer .quizStep").each(function () {
      if ($(this).index() >= currentNum) {
        $(this).find(".quizItem").removeClass("active").removeClass("disabled");
        $(this).find(".quizBoxBottom .btn").text("SKIP");

        if ($(this).closest(".quizStep").attr("name") == "Category") {
          $(this).find(".quizBoxBottom .btn").css('display', 'none');
        }
        
        if ($(this).index() > currentNum) {
          $(this).css("display", "none");
        }
      }
    });
    $(".quiz .quizContainer .quizEnd, #ProductGridContainer").css("display", "none");
    windowScrollTop($(this).closest(".quizStep"));
    filterChange ();
  }
);

$(".quiz .quizContainer .quizStep .quizBox .quizBoxBottom .btn").on("click", function () {
  const type = $(".quizStep[name='Category'] .quizItem.active .itemBox").attr(
    "type"
  );

  var colorType = [];

  $.each(
    $(
      `.quizStep[type="${$(
        '.quiz .quizContainer .quizStep[name="Category"] .quizItem.active .itemBox'
      ).attr("type")}"][name="Function"]`
    ).find(".quizItem.active .itemBox"),
    function (i, item) {
      colorType = jQuery.unique([
        ...colorType,
        $(item).attr("Patterned") != undefined ? "Patterned" : "Solid",
      ]);
    }
  );

  if (
    $(this).closest(".quizStep").attr("name") == "Function" &&
    colorType.length < 2 &&
    $(this)
      .closest(".quizStep")
      .find(".quizItem.active .itemBox")
      .attr("Patterned") == undefined
  ) {
    quizStepChange(
      type,
      parseInt($(this).closest(".quizStep").attr("step")) + 1
    );
  } else {
    quizStepChange(type, parseInt($(this).closest(".quizStep").attr("step")));
  }

  $(this)
    .closest(".quizStep")
    .find(".quizBoxTop .btn")
    .css("display", "block");
  $(this).closest(".quizStep").find(".quizItem").addClass("disabled");

  filterChange();
});

$(".quiz .quizContainer .quizEnd .quizBox .quizBoxTop .btn").on(
  "click",
  function () {
    $(".quiz .quizContainer .quizStart .quizBox .btn").click();
  }
);
